import {
  GA_ECOMMERCE_FIELDS,
  GTM_ENHANCED_CONVERSION_FIELDS,
  GTM_EVENTS,
} from '_constants/analytics';

export const createLeadEventBody = (data) => {
  const enhancedConversions = {
    [GTM_ENHANCED_CONVERSION_FIELDS.customerPhone]: data.customer.phone,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerEmail]: data.customer.email,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerFirstName]: data.customer.firstName,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerLastName]: data.customer.lastName,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerCity]:
      data.customer.billingAddress?.city,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerCountry]:
      data.customer.billingAddress?.country,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerStreet]:
      data.customer.billingAddress?.address1,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerState]:
      data.customer.billingAddress?.state,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerZip]:
      data.customer.billingAddress?.zip,
  };

  return {
    dataLayer: {
      event: GTM_EVENTS.lead,
      eventProps: { enhancedConversions },
    },
  };
};

export const createSaleEventBody = (data) => {
  const items = data.products?.map((product) => ({
    [GA_ECOMMERCE_FIELDS.id]: product.code.code,
    [GA_ECOMMERCE_FIELDS.name]: product.code.customerName,
    [GA_ECOMMERCE_FIELDS.price]: product.price,
    [GA_ECOMMERCE_FIELDS.category]: product.code.category,
    [GA_ECOMMERCE_FIELDS.quantity]: 1,
    [GA_ECOMMERCE_FIELDS.currency]: 'USD',
  }));

  const ecommerce = {
    [GA_ECOMMERCE_FIELDS.cardType]: data.order.paymentDetails.cardType,
    [GA_ECOMMERCE_FIELDS.transactionId]: data.order.crmOrderId,
    [GA_ECOMMERCE_FIELDS.value]: data.order.total,
    [GA_ECOMMERCE_FIELDS.currency]: 'USD',
  };

  if (items?.length) {
    ecommerce.items = items;
  }

  const enhancedConversions = {
    [GTM_ENHANCED_CONVERSION_FIELDS.customerPhone]: data.customer.phone,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerEmail]: data.customer.email,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerFirstName]: data.customer.firstName,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerLastName]: data.customer.lastName,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerCity]:
      data.customer.billingAddress.city,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerCountry]:
      data.customer.billingAddress.country,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerStreet]:
      data.customer.billingAddress.address1,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerState]:
      data.customer.billingAddress.state,
    [GTM_ENHANCED_CONVERSION_FIELDS.customerZip]:
      data.customer.billingAddress.zip,
  };

  return {
    dataLayer: {
      event: GTM_EVENTS.sale,
      eventProps: {
        ecommerce,
        enhancedConversions,
        cardType: data.order.paymentDetails.cardType,
        category: 'purchases',
        action: 'sale',
        label: data.order.crmOrderId,
        value: data.order.total,
      },
    },
  };
};

export const createEcommerceEventProps = (
  productCodes = [],
  productNameMap = {},
  productCategoryMap = {},
  priceMap = {},
  feeMap = {},
  discountCouponType
) => {
  const items = productCodes?.map((code) => ({
    [GA_ECOMMERCE_FIELDS.id]: code,
    [GA_ECOMMERCE_FIELDS.name]: productNameMap[code],
    [GA_ECOMMERCE_FIELDS.price]: priceMap[code] || feeMap[code],
    [GA_ECOMMERCE_FIELDS.category]: productCategoryMap[code],
    [GA_ECOMMERCE_FIELDS.quantity]: 1,
    [GA_ECOMMERCE_FIELDS.currency]: 'USD',
  }));

  const ecommerce = {
    [GA_ECOMMERCE_FIELDS.value]: items.reduce(
      (acc, item) => (acc += item[GA_ECOMMERCE_FIELDS.price]),
      0
    ),
    [GA_ECOMMERCE_FIELDS.currency]: 'USD',
  };

  if (items?.length) {
    ecommerce.items = items;
  }

  if (discountCouponType) {
    ecommerce[GA_ECOMMERCE_FIELDS.coupon] = discountCouponType;
  }

  return { ecommerce };
};

export const createEcommerceItemBody = ({ crmOrderId, product }) => {
  return {
    id: crmOrderId,
    name: product.code.code,
    price: product.price,
    category: product.code.category,
    quantity: '1',
    currency: 'USD',
  };
};

export const createEcommerceTransactionBody = ({ crmOrderId, total }) => {
  return {
    id: crmOrderId,
    revenue: total,
    currency: 'USD',
  };
};
